import React from 'react';
import { Bar } from '@common/components/bar';
import { Container } from '@common/components/container';
import SearchBar from '@common/components/search-bar';
import { useTranslation } from 'react-i18next';
import Icon from '@common/components/icon';

const ArchivedCompetancy = () => {
  const { t } = useTranslation();

  if (true) {
    return (
      <Container.Content className="!tw-h-[calc(100vh-220px)]">
        <div
          className="tw-flex tw-flex-col tw-items-center tw-justify-center !tw-h-full
    tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-4"
        >
          <div
            className="tw-flex tw-flex-col tw-w-[310px]
      tw-items-center tw-justify-center tw-gap-2
      tw-text-center"
          >
            <Icon
              type="briefcase_job"
              size={48}
              className="tw-text-gray-textGray"
            />
            <p className="tw-text-center tw-text-gray-muted tw-text-base">
              {t('performance:no_competencies_description')}
            </p>
          </div>
          <div className="tw-text-gray-muted tw-text-base">
            {t('performance:no_competencies_archived_description')}
          </div>
        </div>
      </Container.Content>
    );
  }

  return (
    <Container.Content>
      <Bar>
        <SearchBar
          onSearch={() => {}}
          placeholder={t('common:search_list_search_placeholder')}
        />
      </Bar>
      <div>Archived Competancy</div>
    </Container.Content>
  );
};

export default ArchivedCompetancy;
